import React, { Suspense } from 'react';
import { useAuthStore } from '../store/authStore';
import { auth } from '../config/firebase';
import LoadingScreen from './LoadingScreen';
import MainLayout from './Layout/MainLayout';
import ObsoleteLanding from '../pages/ObsoleteLanding';

const Dashboard = React.lazy(() => import('../pages/Dashboard'));

/**
 * Accueil en mode obsolète : landing publique, ou dashboard si admin connecté.
 */
const ObsoleteHome: React.FC = () => {
  const { user, isAdmin, loading, initialized } = useAuthStore();

  if (!initialized || (loading && !initialized)) {
    return <LoadingScreen />;
  }

  if (user && isAdmin && auth?.currentUser) {
    return (
      <Suspense fallback={<LoadingScreen />}>
        <MainLayout>
          <Dashboard />
        </MainLayout>
      </Suspense>
    );
  }

  return <ObsoleteLanding />;
};

export default ObsoleteHome;
